import React from 'react';
import { Cell, PieChart, Pie, ResponsiveContainer, Sector, Text } from 'recharts';
import PieChartTemplate2 from './PieChartTemplate2';
import PieChartTemplate3 from './PieChartTemplate3';

const renderActiveShapeSmall = (props) => {
  const RADIAN = Math.PI / 180;
  const { cx, cy, midAngle, innerRadius, outerRadius, startAngle, endAngle,
    fill, payload, percent, value } = props;
  const sin = Math.sin(-RADIAN * midAngle);
  const cos = Math.cos(-RADIAN * midAngle);
  const sx = cx + (outerRadius + 10) * cos;
  const sy = cy + (outerRadius + 10) * sin;
  const mx = cx + (outerRadius + 30) * cos;
  const my = cy + (outerRadius + 30) * sin;
  const ex = mx + (cos >= 0 ? 1 : -1) * 22;
  const ey = my;
  const textAnchor = cos >= 0 ? 'start' : 'end';

  return (
    <g>
      <Sector
        cx={cx}
        cy={cy}
        innerRadius={innerRadius}
        outerRadius={outerRadius}
        startAngle={startAngle}
        endAngle={endAngle}
        fill={fill}
      />
      <Sector
        cx={cx}
        cy={cy}
        startAngle={startAngle}
        endAngle={endAngle}
        innerRadius={outerRadius + 6}
        outerRadius={outerRadius + 10}
        fill={fill}
      />
      <path d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`} stroke={fill} fill="none" />
      <circle cx={ex} cy={ey} r={2} fill={fill} stroke="none" />
      <text x={ex + (cos >= 0 ? 1 : -1) * 12} fontSize={12} y={ey} textAnchor={textAnchor} fill={fill}>{payload.name}</text>
      <text x={ex + (cos >= 0 ? 1 : -1) * 12} fontSize={12} y={ey} dy={18} textAnchor={textAnchor} fill="#999">
        {`${(percent * 100).toFixed(2)}%`}
      </text>
    </g>
  );
};

const renderActiveShape = (props) => {
  const RADIAN = Math.PI / 180;
  const { cx, cy, midAngle, innerRadius, outerRadius, startAngle, endAngle,
    fill, payload, percent, value } = props;
  const sin = Math.sin(-RADIAN * midAngle);
  const cos = Math.cos(-RADIAN * midAngle);
  const sx = cx + (outerRadius + 10) * cos;
  const sy = cy + (outerRadius + 10) * sin;
  const mx = cx + (outerRadius + 30) * cos;
  const my = cy + (outerRadius + 30) * sin;
  const ex = mx + (cos >= 0 ? 1 : -1) * 22;
  const ey = my;
  const textAnchor = cos >= 0 ? 'start' : 'end';

  return (
    <g>
      <Sector
        cx={cx}
        cy={cy}
        innerRadius={innerRadius}
        outerRadius={outerRadius}
        startAngle={startAngle}
        endAngle={endAngle}
        fill={fill}
      />
      <Sector
        cx={cx}
        cy={cy}
        startAngle={startAngle}
        endAngle={endAngle}
        innerRadius={outerRadius + 6}
        outerRadius={outerRadius + 10}
        fill={fill}
      />
      <path d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`} stroke={fill} fill="none" />
      <circle cx={ex} cy={ey} r={2} fill={fill} stroke="none" />
      <text x={ex + (cos >= 0 ? 1 : -1) * 12} y={ey} textAnchor={textAnchor} fill={fill}>{payload.name}</text>
      <text x={ex + (cos >= 0 ? 1 : -1) * 12} y={ey} dy={18} textAnchor={textAnchor} fill="#999">
        {`${(percent * 100).toFixed(2)}%`}
      </text>
    </g>
  );
};


const renderActiveShapeVerySmall = (props) => {
  const RADIAN = Math.PI / 180;
  const { cx, cy, midAngle, innerRadius, outerRadius, startAngle, endAngle,
    fill, payload, percent, value } = props;
  const sin = Math.sin(-RADIAN * midAngle);
  const cos = Math.cos(-RADIAN * midAngle);
  const sx = cx + (outerRadius + 10) * cos;
  const sy = cy + (outerRadius + 10) * sin;
  const mx = cx + (outerRadius + 30) * cos;
  const my = cy + (outerRadius + 30) * sin;
  const ex = mx + (cos >= 0 ? 1 : -1) * 22;
  const ey = my;
  const textAnchor = cos >= 0 ? 'start' : 'end';

  return (
    <g>
      <Sector
        cx={cx}
        cy={cy}
        innerRadius={innerRadius}
        outerRadius={outerRadius}
        startAngle={startAngle}
        endAngle={endAngle}
        fill={fill}
      />
      <Sector
        cx={cx}
        cy={cy}
        startAngle={startAngle}
        endAngle={endAngle}
        innerRadius={outerRadius + 6}
        outerRadius={outerRadius + 10}
        fill={fill}
      />
      <path d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`} stroke={fill} fill="none" />
      <circle cx={ex} cy={ey} r={2} fill={fill} stroke="none" />
      <text x={ex + (cos >= 0 ? 1 : -1) * 12} y={ey} fontSize={8} textAnchor={textAnchor} fill={fill}>{payload.name}</text>
      <text x={ex + (cos >= 0 ? 1 : -1) * 12} y={ey} fontSize={8} dy={18} textAnchor={textAnchor} fill="#999">
        {`${(percent * 100).toFixed(2)}%`}
      </text>
    </g>
  );
};

export default class PIECHART extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeIndex: 0
    }
  }

  onPieEnter = (data, index) => {
    this.setState({
      activeIndex: index,
    });
  }

  getTotalData = (graphData) => {
    let total = 0;
    graphData && graphData.map((item, index) => {
      total = total + Number(item.yProperties)
    });
    return total;
  }

  getData = (subTitle, data) => {
    let f = subTitle.split('[');
    f = f[1] && f[1].split(']')
    data.map(d => {
      if (d.name == f[0]) {
        subTitle = subTitle.split('{{');
        const tmp = subTitle[1].split('}}');
        subTitle = subTitle[0] + ` ${d.value} ` + tmp[1]
      }
    })
    return subTitle;
  }

  render() {
    const { graphData, colors, legendName, xLabel, companyDetails, yLabel, graphHeight, reportPrimaryColor,
      allowAddition, generatedActionCodeForAllowAddition, inlineActions, triggerAction, workflow, triggerData, pieConfig } = this.props;
    let reportLibraryTemplate = companyDetails && companyDetails.companySettings && companyDetails.companySettings.reportLibraryTemplate ? companyDetails.companySettings.reportLibraryTemplate : "TEMPLATE_ONE"
    reportLibraryTemplate = pieConfig && pieConfig.pieReportTemplate ? pieConfig.pieReportTemplate.value : reportLibraryTemplate
    const COLORS = colors;
    let data = [];
    graphData && graphData.map((item, index) => {
      const newItem = {
        name: item.xProperties,
        value: item.yProperties
      }
      data.push(newItem);
    });

    let title = pieConfig && pieConfig.title;
    let subTitle = pieConfig && pieConfig.subTitle;

    if (title && title.indexOf('{{total}}') != -1) {
      const total = this.getTotalData(graphData)
      title = title.replace('{{total}}', total);
    }
    if (subTitle && subTitle.indexOf('{{total}}') != -1) {
      const total = this.getTotalData(graphData)
      subTitle = subTitle.replace('{{total}}', total);
    }

    if (title && title.indexOf('{{data') != -1) {
      title = this.getData(subTitle, data)
    }

    if (subTitle && subTitle.indexOf('{{data') != -1) {
      subTitle = this.getData(subTitle, data)
    }

    if (reportLibraryTemplate === "TEMPLATE_TWO" || reportLibraryTemplate == 'template2') {
      return <PieChartTemplate2 {...this.props} />
    }

    if (reportLibraryTemplate === "TEMPLATE_THREE" || reportLibraryTemplate == 'template3') {
      return <PieChartTemplate3 {...this.props} />
    }


    if (reportLibraryTemplate === "TEMPLATE_ONE" && graphHeight < 301 && graphHeight > 200) {
      return (
        <div style={{ width: '100%', cursor: 'pointer' }} className='reportMainContainer'>
          <ResponsiveContainer height={graphHeight / 2 + 30} width={'99%'}>
            <PieChart width={graphHeight / 2}>
              <Pie
                dataKey="value"
                innerRadius={10}
                outerRadius={10} data={data}
                fill="#8884d8"
                onMouseEnter={this.onPieEnter}
                activeShape={renderActiveShapeVerySmall}
                paddingAngle={25} minAngle={25}
                activeIndex={this.state.activeIndex}
                label={renderActiveShapeVerySmall}
              >
                {
                  data.map((entry, index) => <Cell key={index} fill={reportPrimaryColor && index === 0 ? reportPrimaryColor : COLORS[index % COLORS.length]} />)
                }
              </Pie>
            </PieChart>
          </ResponsiveContainer>
          <div>
            {
              pieConfig && pieConfig.title && <p className='d-flex justify-content-center' style={{ fontWeight: 800, margin: 0, fontSize: 14 }}>{title}</p>
            }
            {
              pieConfig && pieConfig.subTitle && <p className='d-flex justify-content-center' style={{ fontWeight: 400, fontSize: 12, margin: 0 }}>{subTitle}</p>
            }
          </div>
        </div>
      );
    }

    if (reportLibraryTemplate === "TEMPLATE_ONE" && graphHeight < 301) {
      return (
        <div style={{ width: '100%', cursor: 'pointer' }} className='reportMainContainer'>
          <ResponsiveContainer height={graphHeight / 2 + 30} width={'99%'}>
            <PieChart width={graphHeight / 2}>
              <Pie
                dataKey="value"
                innerRadius={20}
                outerRadius={20} data={data}
                fill="#8884d8"
                onMouseEnter={this.onPieEnter}
                activeShape={renderActiveShapeSmall}
                paddingAngle={20} minAngle={20}
                activeIndex={this.state.activeIndex}
                label={renderActiveShapeSmall}
              >
                {
                  data.map((entry, index) => <Cell key={index} fill={reportPrimaryColor && index === 0 ? reportPrimaryColor : COLORS[index % COLORS.length]} />)
                }
              </Pie>
            </PieChart>
          </ResponsiveContainer>
          <div>
            {
              pieConfig && pieConfig.title && <p className='d-flex justify-content-center' style={{ fontWeight: 800, margin: 0, fontSize: 14 }}>{title}</p>
            }
            {
              pieConfig && pieConfig.subTitle && <p className='d-flex justify-content-center' style={{ fontWeight: 400, fontSize: 12, margin: 0 }}>{subTitle}</p>
            }
          </div>
        </div>
      );
    }


    if (reportLibraryTemplate === "TEMPLATE_ONE" && graphHeight > 301 && graphHeight < 400) {
      return (
        <div style={{ width: '100%', cursor: 'pointer' }} className='reportMainContainer'>
          <ResponsiveContainer height={graphHeight} width={'99%'}>
            <PieChart width={graphHeight}>
              <Pie
                dataKey="value"
                innerRadius={55}
                outerRadius={70} data={data}
                fill="#8884d8"
                onMouseEnter={this.onPieEnter}
                activeShape={renderActiveShapeSmall}
                activeIndex={this.state.activeIndex}
                label={renderActiveShapeSmall}
              >
                {
                  data.map((entry, index) => <Cell key={index} fill={reportPrimaryColor && index === 0 ? reportPrimaryColor : COLORS[index % COLORS.length]} />)
                }
              </Pie>
            </PieChart>
          </ResponsiveContainer>
          <div>
            {
              pieConfig && pieConfig.title && <p className='d-flex justify-content-center' style={{ fontWeight: 800, margin: 0, fontSize: 14 }}>{title}</p>
            }
            {
              pieConfig && pieConfig.subTitle && <p className='d-flex justify-content-center' style={{ fontWeight: 400, fontSize: 12, margin: 0 }}>{subTitle}</p>
            }
          </div>
        </div>
      );
    }


    return (
      <div style={{ width: '100%', cursor: 'pointer' }} className='reportMainContainer'>
        {
          reportLibraryTemplate === "TEMPLATE_ONE" && <ResponsiveContainer height={graphHeight}>
            <PieChart>
              <Pie
                dataKey="value"
                innerRadius={75}
                outerRadius={100} data={data}
                fill="#8884d8"
                onMouseEnter={this.onPieEnter}
                activeShape={renderActiveShape}
                activeIndex={this.state.activeIndex}
                label={renderActiveShape}
              >
                {
                  data.map((entry, index) => <Cell key={index} fill={reportPrimaryColor && index === 0 ? reportPrimaryColor : COLORS[index % COLORS.length]} />)
                }
              </Pie>
            </PieChart>
          </ResponsiveContainer>
        }
        <div style={pieConfig && pieConfig.title ? { marginTop: '-7%' } : {}}>
          {
            pieConfig && pieConfig.title && <p className='d-flex justify-content-center' style={{ fontWeight: 800, margin: 0, fontSize: 14 }}>{title}</p>
          }
          {
            pieConfig && pieConfig.subTitle && <p className='d-flex justify-content-center' style={{ fontWeight: 400, fontSize: 12, margin: 0 }}>{subTitle}</p>
          }
        </div>
      </div>
    );
  }
}